<script>
/* eslint-disable import/no-extraneous-dependencies */
import { LorryReceiptGenerationCategory } from 'pando-constants';
import { uniq, compact } from 'lodash';
import { mapGetters } from 'vuex';
import LrNumberListOnConfigMixin from '@common/mixins/document/LrNumberListOnConfigMixin';

const LrNumberListShipperMixin = {
  mixins: [LrNumberListOnConfigMixin],
  computed: {
    ...mapGetters({
      lr: 'order/lr',
      depots: 'app/otherDepots',
      allMaterials: 'order/materials',
      configurations: 'app/configurations',
    }),
    isMultiDropGateConfig() {
      return this.configurations && this.configurations.multi_drop_at_gate_level;
    },
    // return map of {id}_{gate_id} map
    getDepotGateMap() {
      return this.depots.reduce((acc, depot) => {
        if (depot.gates && depot.gates.length) {
          depot.gates.forEach((gate) => {
            acc[`${depot.id}_${gate.id}`] = gate;
          });
        }
        return acc;
      }, {});
    },
  },
  methods: {
    getLrNumberList(destinationDetails) {
      this.destination = this.destination || {};
      if (this.lr && this.lr.length) {
        const sourceDestLR = this.lr.find((lrDetails) => {
          if (this.configurations && this.configurations.multi_drop_at_gate_level
         && lrDetails.gate_id) {
            return (
              lrDetails.destination_location_id === this.destination.location_id &&
            lrDetails.gate_id === this.destination.gate_id &&
            lrDetails.material_invoice_no
            );
          }
          return (
            lrDetails.destination_location_id === this.destination.location_id &&
          lrDetails.material_invoice_no
          );
        });
        if (sourceDestLR) {
          return [];
        }
      }
      const lrGenerateCategory = (this.orderDetails && this.orderDetails.lr_type) ||
       (this.configurations && this.configurations.lorry_receipt_generate_category);
      let divisionList = [];
      if (lrGenerateCategory === LorryReceiptGenerationCategory.DIVISION_WISE) {
        let materialsListDestination = [];
        if (this.allMaterials && this.allMaterials.materials.length) {
          if (this.isMultiDropGateConfig
        && destinationDetails.gate_id) {
            materialsListDestination = this.allMaterials.materials.filter(
              material => material.destination_location_id === destinationDetails.location_id &&
              material.destination_gate_id === destinationDetails.gate_id,
            );
          } else {
            materialsListDestination = this.allMaterials.materials.filter(
              material => material.destination_location_id === destinationDetails.location_id,
            );
          }
          divisionList = materialsListDestination.map(material => material.division);
          divisionList = compact(uniq(divisionList));
        }
      }
      const result = this.getLrNumberDetailsDisplay({
        orderDetails: this.orderDetails,
        destinationDetails,
        lorryReceipts: this.lr,
        lrGenerateCategory,
        depotDetails: this.getDepotGateMap,
        divisionList,
        isMultiDropGateConfig: this.isMultiDropGateConfig,
      });
      return result;
    },
    getMaterialLRList(destinationDetails) {
      const result = this.getMaterialLRDisplayDetails({
        orderDetails: this.orderDetails,
        destinationDetails,
        lorryReceipts: this.lr,
        isMultiDropGateConfig: this.isMultiDropGateConfig,
      });
      return result;
    },
  },
};
export default LrNumberListShipperMixin;
</script>
